import styled from 'styled-components';
import { Button, View } from '../../ui';
import { TIMELINE_COLORS } from '../timelineStyles';

export const SuggestionControlsContainer = styled(View)`
  background-color: ${({ theme }) => theme.colors.orderStatus.suggested};
  align-items: center;
  justify-content: center;
  padding: 5px;
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
export const SuggestionControlsButton = styled(Button)`
  background-color: ${TIMELINE_COLORS.suggestionButton};
  width: auto;
`;
